export const getCookie = (name: string) => {
  const cookieName = `${document.cookie};`.match(new RegExp(`${name}=.*;`));
  return cookieName && cookieName[0].split(/=|;\s/)[1];
};
